export default __webpack_public_path__ + "static/media/DE-LogoMain.90b31164.png";